import { Component, Input, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';

import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';

@Component({
    selector: 'brand-mentions',
    templateUrl: './brand-mentions.component.html',
    styleUrls: ['./brand-mentions.component.scss']
})
export class BrandMentionsComponent implements AfterViewInit, OnChanges {
    private readonly _printComponentName = 'BrandMentionsComponent';

    public hasNoData = true;
    public readonly placeHolderSizes = [1, 3, 2, 4, 2, 2, 1, 4, 2, 3, 3, 2, 3, 2, 3, 3, 2, 2, 1, 3, 2, 3, 2];

    @Input() brandMentions: string[];
    @Input() printMode: boolean;
    @Input() isFetchingData: boolean;

    constructor(private _pdfService: PdfExportService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.brandMentions) {
            const brandMentions = changes.brandMentions.currentValue;
            this.hasNoData = !Array.isArray(brandMentions) || brandMentions.length === 0;
        }
    }

    ngAfterViewInit(): void {
        this._pdfService.incrementNumberReportReady(this._printComponentName);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/brand-mentions/brand-mentions.component.ts